/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';

interface UseInfiniteScrollProps {
  loadMore?: (options?: any) => void;
  hasMore: boolean;
}

const useInfiniteScroll = ({loadMore, hasMore}: UseInfiniteScrollProps) => {
  const {ref, inView} = useInView({
    threshold: 0
  });

  useEffect(() => {
    if (hasMore && inView) loadMore?.();
  }, [hasMore, inView, loadMore]);

  return ref;
};

export default useInfiniteScroll;
